import appPricing from "../../views/appSettings/pricing.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("pricing", {
    url: "pricing/:id",
    parent: "app",
    views: {
      view: {
        template: appPricing,
      },
    },
    reloadOnSearch: false,
    data: { title: "Pricing" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/pricing/pricing.urls.js